import type { ReactNode } from 'react';

import type { ButtonOrLinkData } from '#/components/ButtonOrLink/ButtonOrLinkData';

import {
  SearchHitActions,
  SearchHitCardInner,
  SearchHitContent,
  SearchHitHoverEffect,
  SearchHitLink,
} from './SearchHit.styled';

type Props = {
  actions?: ReactNode;
  highlighted?: boolean;
  children: ReactNode;
  listingLinkData: ButtonOrLinkData;
  onClick?: () => void;
};

export function SearchHitInteractiveContentWrapper({
  actions,
  highlighted,
  children,
  listingLinkData,
  onClick,
}: Props) {
  if (actions)
    return (
      <SearchHitCardInner $highlighted={Boolean(highlighted)}>
        <SearchHitContent>{children}</SearchHitContent>
        <SearchHitActions>{actions}</SearchHitActions>
      </SearchHitCardInner>
    );

  return (
    <SearchHitLink
      $highlighted={Boolean(highlighted)}
      data={listingLinkData}
      onClick={onClick}
    >
      <SearchHitHoverEffect />
      <SearchHitContent>{children}</SearchHitContent>
    </SearchHitLink>
  );
}
